import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faEuroSign, faAward } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import PropTypes from 'prop-types';
import createFolderIcon from '../../assets/img/create-folder.svg';
import calendarIconBlue from '../../assets/img/calendar-blue.svg';
import dashboardIcon from '../../assets/img/dashboard.svg';
import { ROLE_ID } from '../../config';
import { Auth } from '../../config/configuration/react';

function getUserRole() {
  const roleId = Auth.roleId();
  return _.get(ROLE_ID, roleId);
}

const MenuNavBottom = ({ active }) => {
  const role = getUserRole();
  const isNrmUser = Auth.isNrmUser();
  const isCarcheckUser = Auth.isCarcheckUser();

  return (
    <div className="menu-nav-bottom">
      <div className="wrapper">
        {isNrmUser && (
          <>
            <Link to="/dashboardnrm?currentTab=onGoingNrm" className={active === 'dashboardNrm' ? 'active' : ''}>
              <FontAwesomeIcon icon={faAward} size="lg" />
            </Link>
            <span className="separator" />
          </>
        )}
        {isCarcheckUser && (
          <>
            <Link to="/forms?currentTab=buyerOnGoing" className={active === 'dashboard' ? 'active' : ''}>
              <img src={dashboardIcon} alt="" />
            </Link>
            <span className="separator" />
          </>
        )}

        {role !== 'buyer' && isCarcheckUser && (
          <>
            <Link to="/supervision?currentTab=supervisorAwaiting" className={active === 'supervision' ? 'active' : ''}>
              <FontAwesomeIcon icon={faEuroSign} size="lg" />
            </Link>
            <span className="separator" />
          </>
        )}
        {(isCarcheckUser || isNrmUser) && (
          <>
            <Link to="/search" className={active === 'search' ? 'active' : ''}>
              <FontAwesomeIcon icon={faSearch} size="lg" />
            </Link>
            <span className="separator" />
          </>
        )}

        {(isCarcheckUser || isNrmUser) && role !== 'viewer' &&(
          <>
            <Link to="/files/create" className={active === 'createFolder' ? 'active' : ''}>
              <img src={createFolderIcon} alt="" />
            </Link>
            <span className="separator" />
          </>
        )}
        {isCarcheckUser && (
          <>
            <Link to="/calendar" className={active === 'calendar' ? 'active' : ''}>
              <img src={calendarIconBlue} alt="" />
            </Link>
            <span className="separator" />
          </>
        )}
      </div>
    </div>
  );
};

MenuNavBottom.propTypes = {
  active: PropTypes.string.isRequired,
};

export default memo(MenuNavBottom);
